// community-registry.js - Unified community affiliate data store

// ============================================================
// LOGGING WRAPPER
// ============================================================

function log(...args) {
  const LEVELS = new Set(['info', 'success', 'silent-success', 'warning', 'error', 'pending']);
  let type = 'info';
  if (args.length > 1 && typeof args[args.length - 1] === 'string' && LEVELS.has(args[args.length - 1])) {
    type = args.pop();
  }
  const msg = args.map(v => typeof v === 'string' ? v : JSON.stringify(v)).join(' ');
  if (window.debugLog) window.debugLog(msg, type);
  else console.log(msg);
}

// ============================================================
// COMMUNITY REGISTRY
// ============================================================

class CommunityRegistry {
  constructor() {
    this.communities = new Map(); // id -> community data
    this.communityOrder = []; // Ordered list of community IDs for UI
    this.initCommunities();
  }

  // Initialize hardcoded community affiliates
  initCommunities() {
    const communities = [
      {
        id: 'aquavaults',
        name: 'AquaVaults',
        logo: '/assets/logo-transparent.png',
        description: 'A premier Solana swap aggregator with automated trading features where users choice matter and communities are able to earn fees.',
        website: 'https://aquavaults.com',
        socials: {
          twitter: 'https://x.com/aquavaults',
        },
        jupiterAffiliate: '', // J793jNSvzKQ7bbu2ZL4sHxF8mjBtcZ3nFZG5u4Jrpx6T
        tokenVaults: {
          // Token mint address -> fee vault address
          'So11111111111111111111111111111111111111112': 'FPLExQA2aVi1R2gsank2f8aVV7mJNke8LzZc4hcdMQTQ', // SOL
          'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v': '4VhsDo3odQQp3FYK3L4u1DeMgFivauWeXxwdVNY7L4ow', // USDC
          'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB': 'CWwzp3cerMSL91q52FCePf39rzAdc8iASGroALYQ41Ln', // USDT
          '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq': '738W61KepfEfyRLdjWJNBGTPUtsHP2Z3tQs1ropYyfQG', // wPOND
          'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A': '5CfLwFLkJU9kLvcziVBdbC3aCjDMW9F13xzxuw3HQJ2y', // hSOL
          'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So': 'E4dL4wYuHg1Kg84bBcwjjcr5ZcVwF1EWYpLfJHVBC7jF', // mSOL
          'B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B': 'Abdn3hAgi88LW1GdCRB5s8gpoEKh6xeJc9EmW6dUHWBi', // PepeOnSOL
          '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN': 'DeqCpGPrnYUXwR4sqkXi4UrkLgNoer6SURu3UEEXSuu2', // OFFICIAL TRUMP (TRUMP)
          '27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4': 'E3L1A7Vib38yJ71Gea8T46K3aBUXbhis82Qax7i1MeyH', // JLP
          'pumpCmXqMfrsAkQ5r49WcJnRayYRqmXz6ae8H7H9Dfn': '2zcPArV6HvFF3ZJvErJHDV16HSnh2HBwC8GUSv3FpDi6', // PUMP
          '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh': 'aTw4RzZ2UM9EpXkcZUtgbzWw21ez9b52XkVG7VNC1Mb', // WBTC
          'J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn': 'Ez7pa1U2fH558miutw3gqu2HUWUMCxtsXaRxNAmHYrFj', // Jito Staked SOL (JitoSOL)
          'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN': '7o2CEcFbgWTp7wCRAPC1mLJPP4Xb1AMuAM9imaB8chYd', // Jupiter (JUP)
          'A7bdiYdS5GjqGFtxf17ppRHtDKPkkRqbKtR27dxvQXaS': '9AD9b9ojrqXKA7xYagNbrq1FMjLDJ1KwkhtiMbVxsChc', // ZEC
          'jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v': '4rco1Mruot7TcyJW7F2Sm7ZsN4qGxgR6GsqLnNUs3YNB', // Jupiter Staked SOL (JupSOL)
          'METvsvVRapdj9cFLzq4Tr43xK4tAjQfwX76z3n6mWQL': 'DK3zbF8xch2DStq5mP9Ai5QQ3FePWx3JTsgpTRjXsHLa', // Meteora (MET)
          '4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R': 'AWjULjF8ggTepAjV3Ngf4Y5fjksnCF9bk16MyCW2sRsm', // Raydium (Ray)
          '98sMhvDwXj1RQi5c5Mndm3vPe9cBqPrbLaufMXFNMh5g': 'HrY6ybtJSdkXiCniPVptbzTDmcMK3Rk7EkdWspBgfSdd', // HYPE
          '2zMMhcVQEXDtdE6vsFS7S7D5oUodfJHE8vd1gnBouauv': '8ny2gN5uUotowaGhWNxPC5DjK25EGohdRvfeMAkRejYr', // Pudgy Penguins (PENGU)
        },
        backupWallet: '9PAPuQ12ZPR5vWfrZQE1qEpNDXMWVb45Yyi2EgfGB7Us' // Backup wallet for non-vault tokens
      },
      {
        id: 'pond0x',
        name: 'Pond0x',
        logo: '/assets/pond-logo-transparent.png',
        description: 'Pond0x is a decentralized exchange (DEX) and ecosystem that rewards users for their participation in activities like swapping tokens on Ethereum and Solana, and contributing mining power from any internet capable device. Key tokens include $PNDC, $PORK (on Ethereum), $wPOND, and $pondSOL (on Solana), all tied to the "Crypto 2.0" vision where users are king and participation is rewarded.',
        website: 'https://pond0x.com',
        socials: {
          twitter: '',
        },
        jupiterAffiliate: '', // ETrCXCK7d67MbbY18CnZZWXp8o9b3GAWwwiCVxguouf
        tokenVaults: {
          // Token mint address -> fee vault address
      // 'So11111111111111111111111111111111111111112': '9hCLuXrQrHCU9i7y648Nh7uuWKHUsKDiZ5zyBHdZPWtG', // SOL
      // 'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v': '6NqvoPpSYCPEtLEukQaSNs7mS3yK6k285saH9o3vgC96', // USDC
      // 'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB': '5LmFGjbae5iWejFVT8UiRLggh1me22nTetmere8SjwKy', // USDT
      // '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq': 'GKHmDYWPE8Bf74xDntnpx4hi4H7pRp3HK5QYvPyXGEiU', // wPOND
      // 'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A': '4jkVjzXtrCuxQus3neMtLfNL4wZhsPmm9fKGXoLMXqsG', // hSOL
      // 'B5WTLaRwaUQpKk7ir1wniNB6m5o8GgMrimhKMYan2R6B': '3qGSU2RySrjvQ2iGMts2HZ4ssGVSrBUSGL4jN7LHGhgo', // PepeOnSOL
        },
        backupWallet: '1orFCnFfgwPzSgUaoK6Wr3MjgXZ7mtk8NGz9Hh4iWWL' // Backup wallet for non-vault tokens
      },
      {
        id: 'demplar',
        name: 'Knights Demplar',
        logo: '/assets/demplar-logo.png',
        description: 'Official community for the Demplarverse RPG — adventure, quests, land claims, character cards & Xspace events in a fantasy world on Solana.',
        website: 'https://knightsdemplar.com',
        socials: {
          twitter: 'https://x.com/DemplarOfficial',
          discord: 'https://discord.gg/EyfXFUapAw',        },
        jupiterAffiliate: '', // BB3oWu9RuGqruG72DnpcorNECCHvkutShhrA5yS2BPey
        tokenVaults: {
          // Token mint address -> fee vault address
          'So11111111111111111111111111111111111111112': '66eVsh7mjgaUpvpFPkGZz2tVawMD8SsSLJFaRHfBnMV2', // SOL
          'EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v': 'D5nu3uhRUEtg4LKsQWaLTKZm2kuWr5b6eECHmzsfJwyZ', // USDC
          'Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB': 'FFcjeh1zSHUs28QbD3jaEYFaANBZymXwEqAp8kkX8Pvo', // USDT
          '3JgFwoYV74f6LwWjQWnr3YDPFnmBdwQfNyubv99jqUoq': '9Fj7946DGezyBHVDszXqomTXi9QkBzewZdPmvp5qcB24', // wPOND
          'he1iusmfkpAdwvxLNGV8Y1iSbj4rUy6yMhEA3fotn9A': '3XHaLXZ9JeSoyp1zpvbokSawS41TzMEwTRfsEMyHG89U', // hSOL
          'mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So': 'CUMyunJB4m9nsdAwvJiBoUC5N95fWM8rVPHjVk7ke2E3', // mSOL
          '3NZ9JMVBmGAqocybic2c7LQCJScmgsAZ6vQqTDzcqmJh': 'y1xbqnDtoxFw6BgfCcyunqU6SrUmJdNZ8ttey2hPR4E', // WBTC
          '27G8MtK7VtTcCHkpASjSDdkWWYfoqT6ggEuKidVJidD4': 'CHoGcdW3W5HLbNX4RqBVHhDYtWyUyWxiBTbLzAgazhZE', // JLP
          '2zMMhcVQEXDtdE6vsFS7S7D5oUodfJHE8vd1gnBouauv': '95nq7FRHt6DHFd7Pw3QPw4D1kf7c1zzJCM31oE93oX4W', // Pudgy Penguins (PENGU)
          '5UUH9RTDiSpq6HKS6bp4NdU9PNJpXRXuiw6ShBTBhgH2': '6k43fDMasbmRCX1iojSQb1MviGtbHEq9cmpasU1ofYrq', // TROLL
          'METvsvVRapdj9cFLzq4Tr43xK4tAjQfwX76z3n6mWQL': 'JBrYLP2dtMJoYZJp5BwMKmrqZRy4GhT2BbSfQRmXa4KS', // Meteora (MET)
          'A7bdiYdS5GjqGFtxf17ppRHtDKPkkRqbKtR27dxvQXaS': '6uGhmjQ5ynSyspFypZQ34DeSpft1v8BPnLaNKvuErTVY', // ZEC
          'J1toso1uCk3RLmjorhTtrVwY9HJ7X8V9yYac6Y7kGCPn': '5ft9xv9mzRHNQeSm37Ui4aFjgBvwJVsRgAFiD2cpWJnc', // Jito Staked SOL (JitoSOL)
          'jupSoLaHXQiZZTSfEWMTRRgpnyFm8f6sZdosWBjx93v': 'C2gPZWUvre2HQaFLMfT5w2ezkNNHaeyRpaZuMcgXM7AE', // Jupiter Staked SOL (JupSOL)
          'JUPyiwrYJFskUPiHa7hkeR8VUtAeFoSYbKedZNsDvCN': '3Vagfe28PsPZofUy5vT2SwJRcJCjHpJMRU791xD7YBfe', // Jupiter (JUP)
          '6p6xgHyF7AeE6TZkSmFsko444wqoP15icUSqi2jfGiPN': 'GYHFVRWsPxfTVdoeHvooh76BGyC5KyZE5J7Lu58NTLPF', // OFFICIAL TRUMP (TRUMP)
        },
        backupWallet: 'DWtssZrEGeSqfskKWBXG5LUiocXobNHtK2cai6rFBazj' // Backup wallet for non-vault tokens
      }
      // Additional communities will be added here
    ];

    communities.forEach(community => {
      this.communities.set(community.id, community);
      this.communityOrder.push(community.id);
    });

    log(`Initialized ${communities.length} community affiliate(s)`, 'silent-success');
  }

  // Get community by ID
  get(id) {
    return this.communities.get(id);
  }

  // Get all communities in order
  getAll() {
    return this.communityOrder.map(id => this.communities.get(id));
  }

  // Check if community exists
  has(id) {
    return this.communities.has(id);
  }

  // Get fee destination for a specific token mint
  // Returns the token vault if available, otherwise returns backup wallet
  getFeeDestination(communityId, tokenMint) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }

    // Check if there's a specific vault for this token
    if (community.tokenVaults && community.tokenVaults[tokenMint]) {
      return community.tokenVaults[tokenMint];
    }

    // Fallback to backup wallet
    if (!community.backupWallet) {
      throw new Error(`Community ${communityId} has no backup wallet configured`);
    }

    return community.backupWallet;
  }

  // Get Jupiter affiliate account for a community
  getAffiliateAccount(communityId) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }
    if (!community.jupiterAffiliate) {
      throw new Error(`Community ${communityId} has no Jupiter affiliate account configured`);
    }
    return community.jupiterAffiliate;
  }

  // Check if a community has a specific token vault
  hasTokenVault(communityId, tokenMint) {
    const community = this.communities.get(communityId);
    if (!community) return false;
    return !!(community.tokenVaults && community.tokenVaults[tokenMint]);
  }
  // Get backup wallet for a community (always returns wallet address, never vault)
  getBackupWallet(communityId) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }
    if (!community.backupWallet) {
      throw new Error(`Community ${communityId} has no backup wallet configured`);
    }
    return community.backupWallet;
  }

  // Get token vault for a specific mint (returns vault address or null, never wallet)
  getTokenVault(communityId, tokenMint) {
    const community = this.communities.get(communityId);
    if (!community) {
      throw new Error(`Community not found: ${communityId}`);
    }
    return (community.tokenVaults && community.tokenVaults[tokenMint]) || null;
  }
}

// ============================================================
// GLOBAL INSTANCE
// ============================================================

window.CommunityRegistry = new CommunityRegistry();